exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-fluid[data-v-0c5cb9b6]{margin:20px 0}.container-fluid .titolo[data-v-0c5cb9b6]{font-size:24px;display:block;width:100%}.container-fluid .input-titolo[data-v-0c5cb9b6]{font-size:24px;width:20%}.container-fluid .descrizione[data-v-0c5cb9b6]{font-size:18px}input[data-v-0c5cb9b6]{width:100%}.fas[data-v-0c5cb9b6]{font-size:20px}.fas.fa-pen[data-v-0c5cb9b6]{color:var(--dark-yellow)}.fas.fa-check[data-v-0c5cb9b6]{color:var(--dark-green)}.row[data-v-0c5cb9b6]{position:relative}.messaggio-successo[data-v-0c5cb9b6]{position:absolute;display:inline-block;right:-50%;top:-100%}", ""]);

// exports
